import { Revenue } from 'components/analytics/revenue/Revenue'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER } from 'configs/analytics/configTableRevenue'
import { useLocation, useSearchParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_REVENUE } from 'services/apiAnalyticRevenue'
import { Alert } from 'avo-ui'

export const RevenueContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [showModalExport, setShowModalExport] = useState(false)
    const { fetching: getRevenueGraph, data: revenueGraph, isLoading: isLoadingGraph } = useFetch(API_REVENUE.GRAPH)
    const { fetching: getRevenueList, data: revenueList, isLoading: isLoadingList } = useFetch(API_REVENUE.LIST)
    const { fetching: exportRevenueList, isLoading: isLoadingExport } = useFetch(API_REVENUE.EXPORT)
    const {
        fetching: getRevenueComparison,
        data: revenueComparison,
        isLoading: isLoadingComparison,
    } = useFetch(API_REVENUE.COMPARISON)

    useEffect(() => {
        const { page, limit, orderBy, orderType, ...queryRest } = query
        getRevenueGraph(queryRest)
        getRevenueComparison(queryRest)
    }, [query?.startDate, query?.endDate])

    useEffect(() => {
        getRevenueList({ ...query })
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const setShowModalExportHandler = (value) => {
        setShowModalExport(value)
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('_')
        onChangeQuery({ orderBy: splitSort[0], orderType: splitSort[1] })
    }

    const onExport = () => {
        const { page, limit, ...queryRest } = query
        exportRevenueList(queryRest, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `Analytic-Revenue-Export-Start_${query?.startDate}-End_${query?.endDate}.xlsx`)
            setShowModalExport(false)
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Analytic Revenue Exported',
            })
        })
    }

    const props = {
        dataComparison: revenueComparison?.data,
        dataGraph: revenueGraph?.data,
        dataList: revenueList?.data,
        query,
        onChangeQuery,
        onSelectSort,
        showModalExport,
        setShowModalExportHandler,
        isLoadingComparison,
        isLoadingGraph,
        isLoadingList,
        isLoadingExport,
        onExport,
    }

    return <Revenue {...props} />
}
